import { FC } from 'react'

import styled from 'styled-components'
import { Controller, useForm } from 'react-hook-form'

import { Input } from 'src/Components/Input/index.tsx'
import { Button } from 'src/Components/Button'
import { device } from 'src/Helpers/constants.ts'
import { Modal } from 'src/Components/Modal'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;

  @media ${device.tabletMax} {
    flex-direction: column;
  }
`

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

const ModalContainer = styled.div`
  padding-top: 45px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export interface AddTypeForm {
  name?: string
}

interface AddTransportTypeModalProps {
  onClose: () => void
  onAddType: (modelType: AddTypeForm) => void
  isOpened: boolean
}

export const AddTransportTypeModal: FC<AddTransportTypeModalProps> = ({
  isOpened,
  onClose,
  onAddType,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<AddTypeForm>()

  const onSubmit = (data: AddTypeForm): void => {
    onAddType(data)
    reset()
    onClose()
  }

  return (
    <Modal opened={isOpened} onClose={onClose} title='Добавить тип техники'>
      <ModalContainer>
        <Container>
          <Controller
            name='name'
            control={control}
            render={({ field }) => (
              <Input
                placeholder='Название'
                label='Название'
                error={errors.name?.message}
                {...field}
              />
            )}
          />
        </Container>
        <ButtonsWrapper>
          <Button onClick={handleSubmit(onSubmit)}>Добавить</Button>
        </ButtonsWrapper>
      </ModalContainer>
    </Modal>
  )
}
